import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Document } from 'src/shared/api';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { takeUntil } from 'rxjs/operators';

export const documentFormConfig: FormConfig<Document> = {
	id: [''],
	title: [''],
	fileName: [''],
	description: [''],
	uploadedOn: [''],
	timeStamp: [''],
	tags: [[]],
	sizeInBytes: [''],
	hideFromCustomer: [false],
	hideFromFieldWorker: [false],
	includeInInvoicing: [false],
};

@Component({
	selector: 'rpshared-edit-document',
	templateUrl: './edit-document.component.html',
})
export class EditDocumentComponent extends CustomFormAccessor<Document>
	implements OnInit {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, documentFormConfig);
	}

	ngOnInit() {
		this.form
			.get('hideFromCustomer')
			.valueChanges.pipe(takeUntil(this.destroyed))
			.subscribe((hideFromCustomer) => {
				if (hideFromCustomer) {
					this.form.get('includeInInvoicing').setValue(false);
					this.form.get('includeInInvoicing').disable();
				} else {
					this.form.get('includeInInvoicing').enable();
				}
			});
		super.ngOnInit();
	}

	get hiddenFromCustomers(): boolean {
		return this.form.get('hideFromCustomer').value;
	}
}
